<template>
  <div class="main">
    <c-panel title="Modelos de veículo" titleIcon="fas fa-bus">
      <!-- Item 21: "registrar as informações dos modelos de veículos utilizados pela entidade". -->
      <crud-simples endpoint="api/transporte-escolar/modelo" :perfis-escrita="[0, 1, 4, 5, 6, 12]" rotuloNovo="NOVO MODELO"
                    nomeSingular="modelo" placeholderBusca="Pesquisar por nome"
                    :campos="campos" :colunas="colunas" :filtroExtra="filtroExtra"></crud-simples>
    </c-panel>
  </div>
</template>

<script>
import CrudSimples from '@/shared/crud-simples/crud-simples.vue'

export default {
  components: { CrudSimples, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'marca_id', label: 'Marca', tipo: 'select', obrigatorio: true, span: 12,
        opcoesDe: 'api/transporte-escolar/marca' },
      { chave: 'nome', label: 'Nome do modelo', obrigatorio: true, span: 12, max: 120 },
      { chave: 'capacidade_padrao', label: 'Capacidade padrão (lugares)', tipo: 'numero', span: 12 },
      { chave: 'combustivel', label: 'Combustível', span: 12, max: 30 }
    ],
    colunas: [
      { chave: 'nome', label: 'Modelo' },
      { chave: 'marca', caminho: 'marca.nome', label: 'Marca', largura: '180px' },
      { chave: 'capacidade_padrao', label: 'Capacidade', largura: '110px', mobileOculto: true },
      { chave: 'combustivel', label: 'Combustível', largura: '130px', mobileOculto: true }
    ],
    filtroExtra: { chave: 'marca_id', label: 'Marca', opcoesDe: 'api/transporte-escolar/marca' }
  })
}
</script>
